<template>
  <v-avatar
    v-bind="{
      ...$attrs,
      ...$props,
      letters: null,
      src: null,
      imgProps: null,
      color: props.letters || props.icon ? props.color : 'bg-transparent',
    }"
    class="e-avatar">
    <slot>
      <v-img v-if="props.src" :src="props.src" aspect-ratio="1/1" cover v-bind="{ ...props.imgProps }">
        <template #placeholder>
          <slot name="placeholder">
            <div class="e-avatar__default-image">
              <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_827_20305)">
                  <rect width="18" height="18" rx="9" fill="#E4F1FF" />
                  <path
                    d="M8.99999 12.6615C4.4813 12.6615 0.818176 16.2238 0.818176 20.6182H17.1818C17.1818 16.2238 13.5187 12.6615 8.99999 12.6615Z"
                    fill="#489FFE" />
                  <ellipse cx="8.91897" cy="7.01232" rx="3.88839" ry="3.73962" fill="#489FFE" />
                </g>
                <defs>
                  <clipPath id="clip0_827_20305">
                    <rect width="18" height="18" rx="9" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </slot>
        </template>
      </v-img>
      <div v-else class="e-avatar__no-image">
        <div v-if="props.letters" class="e-avatar__letters">
          {{ props.letters }}
        </div>
        <div v-else class="e-avatar__default-image">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_827_20305)">
              <rect width="18" height="18" rx="9" fill="#E4F1FF" />
              <path
                d="M8.99999 12.6615C4.4813 12.6615 0.818176 16.2238 0.818176 20.6182H17.1818C17.1818 16.2238 13.5187 12.6615 8.99999 12.6615Z"
                fill="#489FFE" />
              <ellipse cx="8.91897" cy="7.01232" rx="3.88839" ry="3.73962" fill="#489FFE" />
            </g>
            <defs>
              <clipPath id="clip0_827_20305">
                <rect width="18" height="18" rx="9" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </slot>
  </v-avatar>
</template>

<script setup>
import { VAvatar } from 'vuetify/components/VAvatar'
import { VImg } from 'vuetify/components/VImg'

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  letters: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'sky',
  },
  imgProps: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import '../../scss/styles';
.e-avatar {
  &__no-image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  &__letters {
    user-select: none;
    color: $whitebase;
    text-transform: uppercase;
    font-weight: 600;
  }

  &__icon,
  .v-icon {
    color: $whitebase;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__loader {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  &__default-image {
    width: 100%;
    height: 100%;
  }
  &.v-avatar--size-x-small {
    width: 18px;
    height: 18px;
    font-size: 7px;
    font-weight: 600;
  }
  &.v-avatar--size-small {
    width: 28px;
    height: 28px;
    font-size: 11px;
    font-weight: 600;
  }
  &.v-avatar--size-default {
    width: 36px;
    height: 36px;
    font-size: 15px;
    font-weight: 600;
  }
  &.v-avatar--size-large {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
  &.v-avatar--size-x-large {
    width: 64px;
    height: 64px;
    font-size: 18px;
  }
}
</style>
